<script>
import { get } from 'lodash'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      if (!Array.isArray(this.form.links)) {
        this.$set(this.form, 'links', [])
      }
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Title',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true
            }),
            new fields.WYSIWYG({
              label: 'Description',
              modelPath: [this, 'form', 'description'],
              multilingual: true
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'links'],
              items: this.form.links.map((itemLink, i) => {
                return {
                  headerLabel: 'Camp link',
                  fields: [
                    new fields.Link({
                      label: 'Camp link',
                      modelPath: [this, 'form', 'links', i, 'link'],
                      required: true
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  }
}
</script>
